/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_PolishedInputs */

const cs_social_export_caption_polished = /** @type {(inputs: Social_Export_Caption_PolishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek upraven.`)
};

const en_social_export_caption_polished = /** @type {(inputs: Social_Export_Caption_PolishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption polished.`)
};

/**
* | output |
* | --- |
* | "Caption polished." |
*
* @param {Social_Export_Caption_PolishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_polished = /** @type {((inputs?: Social_Export_Caption_PolishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_PolishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_polished(inputs)
	return cs_social_export_caption_polished(inputs)
});